__turbopack_context__.v({
  "blink": "SectionEmptyState-module__lD9PbW__blink",
  "caret": "SectionEmptyState-module__lD9PbW__caret",
  "eyebrow": "SectionEmptyState-module__lD9PbW__eyebrow",
  "message": "SectionEmptyState-module__lD9PbW__message",
  "panel": "SectionEmptyState-module__lD9PbW__panel",
});
